import { EnvKeysEnum, getEnv } from "Utils/environment"

export interface AccountType {
  BG: string
  PG: string
}

export const ANNAN_AKTOR = "Annan kreditgivare"
export const WEB_SOCKET_URL = getEnv(EnvKeysEnum.IceingWebSocketUrl)
export const BANKID_BASE_URL = "bankid:///?autostarttoken="
export const GENERIC_ERROR = "Something went wrong. Please try again later"
export const STRATEGIES = {
  SSN: "SSN",
  BANK_ID: "BANK_ID",
}
export const ACCOUNT_TYPE_OPTIONS = [
  { id: "1", name: "Bankgiro", value: "BG" },
  { id: "2", name: "Plusgiro", value: "PG" },
]
export const ACCOUNT_TYPE: AccountType = {
  BG: "9900",
  PG: "9500",
}
export const LOAN_TYPE_OPTIONS = [
  { id: "1", name: "Lån", value: "Lån" },
  { id: "2", name: "Kredit", value: "Kredit" },
  { id: "3", name: "Avbetalning", value: "Avbetalning" },
]

export enum BanksName {
  klarna = "Klarna",
  santander = "Santander",
  marginalen = "Marginalen",
}
